/* eslint-disable */
import React, { useState, useEffect } from "react";
import Api from "./Api";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import { Link } from "react-router-dom";
import "./style.css";
import PARSE from "html-react-parser";

function BaseRelatedPages({ menus, title, linkComponent }) {
  function renderSplide(menu) {
    const trans = menu?.url?.replace(/-/g, " ");
    const splitTrans = trans?.split("/");

    const asset = menu?.article?.article_assets[0]?.asset?.asset_file;

    const assetBg = menu?.article?.article_assets[1]?.asset?.asset_file;

    return (
      <SplideSlide
        key={menu.id}
        className="w-full xl:h-[426px] mdl:h-[480px] h-[490px] s:h-[500px] "
      >
        <Link to={menu?.url ?? "/"}>
          <div className="absolute inset-0 xl:h-[426px] mdl:h-[480px] h-[490px] s:h-[500px] w-full -z-[1]">
            <img src={assetBg} alt="" className="h-full w-full" />
          </div>
          <div className="p-[45px] xl:h-[426px] mdl:h-[480px] h-[490px] s:h-[500px]  relative">
            <div className="h-[48px] w-[48px] rounded-full bg-white items-center flex justify-center mb-[45px]">
              <img src={asset} alt="" className="w-[24px] h-[24px]" />
            </div>
            <div className="z-[10] ">
              <div className="">
                {splitTrans?.map((t, i) => (
                  <div key={t} className="">
                    {/* {i === splitTrans?.length - 2 && (
                      <div className="capitalize font-inter text-sm">{t}</div>
                    )} */}
                    {i === splitTrans?.length - 1 && (
                      <div className="content-header-style-non-hero">
                        {menu.title}
                      </div>
                    )}
                    {i === splitTrans?.length - 1 && (
                      <div className="content-subheader-style-non-hero pt-[15px]">
                        {menu?.article?.content &&
                          PARSE(menu?.article?.content)}
                      </div>
                    )}
                  </div>
                ))}
              </div>
              {linkComponent}
            </div>
          </div>
        </Link>
      </SplideSlide>
    );
  }

  return (
    <div className="w-full">
      <div className="pb-[45px] header-style-non-hero max-w-[487px]">
        {title}
      </div>
      <Splide
        className="w-full h-full custom-splide-rl"
        options={{
          type: "slide",
          rewind: "false",
          perPage: 3,
          perMove: 1,
          gap: "30px",
          pagination: true,
          arrows: false,
          breakpoints: {
            623: {
              perPage: 1,
              perMove: 1,
            },
            1000: {
              perPage: 2,
              perMove: 1,
            },
            1024: {
              perPage: 3,
              perMove: 1,
            },
            1600: {
              perPage: 3,
              perMove: 1,
            },
            1920: {
              perPage: 3,
              perMove: 1,
            },
            2560: {
              perPage: 3,
              perMove: 1,
            },
          },
        }}
      >
        {menus?.map((menu) => renderSplide(menu))}
      </Splide>
    </div>
  );
}

function SSoft_Related_Pages() {
  const location = useLocation();
  const [menus, setMenus] = useState([]);
  const [trans, setTrans] = useState(null);

  const activeLang = useSelector((state) => state.content.activeLanguage);

  const getMenus = async () => {
    const api = new Api();
    const response = await api.getMenuDetail({ language: activeLang });
    const parsedData = await response;
    const menusData = parsedData;

    setMenus(menusData.data.items);
    return menus;
  };

  const [sections, setSections] = useState([]);
  const getSectionDetail = async () => {
    const api = new Api();
    const response = await api.getSectionDetail({ language: activeLang });
    // console.log(response);
    const parsedData = await response;
    const sectionsData = parsedData;
    // console.log(sectionsData.data.results);
    setSections(sectionsData.data.results);
    setTrans(sectionsData.data.results[0]?.page_url.split("/"));
    return sections;
  };

  useEffect(() => {
    getMenus();
    getSectionDetail();
  }, []);

  // const trans = sections[0]?.page_url.split("/");

  const currentPath =
    trans && trans.length > 0
      ? menus?.filter(
          (men) => men?.title?.replace(/\s+/g, "-").toLowerCase() === trans[1]
        )
      : "";

  const getIdCurrentPath =
    currentPath && currentPath.length > 0
      ? currentPath[0]?.children?.filter(
          (men) => men?.title.replace(/\s+/g, "-").toLowerCase() === trans[2]
        )
      : "";

  const newCurrentPath =
    getIdCurrentPath && getIdCurrentPath.length > 0
      ? currentPath[0]?.children?.filter(
          (men) => men?.id !== getIdCurrentPath[0].id
        )
      : currentPath[0]?.children?.filter(
          (men) => men?.title.replace(/\s+/g, "-").toLowerCase() !== trans[2]
        );

  let title;
  let sectionName;
  let linkComponent;
  if (sections) {
    const sec = sections[0]?.widgets;
    if (sec && sec.length !== 0) {
      sec.forEach((section, i) => {
        switch (i) {
          case 0:
            title = section.widget_contents[0];

            break;
          case 1:
            const contentLink = section.widget_contents[0];

            linkComponent = (
              <div className="text-[#E12726] text-[16px] leading-[150%] absolute bottom-[45px] flex space-x-[10px] items-center justify-center">
                <img
                  src={contentLink?.assets[0]?.asset_file}
                  alt=""
                  className="w-[24px] h-[24px] fill-[#E12726]"
                />
                <div className="">{contentLink?.article_language?.title}</div>
              </div>
            );
            break;
          case 3:
            break;
          default:
            break;
        }
      });
    }
  }

  return (
    <div className="section-container section-margin-x  relative mdl:py-[120px] md:py-[80px] py-[60px]">
      {newCurrentPath && newCurrentPath.length > 0 && (
        <div className="mb-[45px]">
          <BaseRelatedPages
            top={160}
            linkComponent={linkComponent}
            title={
              title?.article_language?.title ||
              "Integrating with our solutions and streamline your operations"
            }
            menus={newCurrentPath || []}
          />
        </div>
      )}
    </div>
  );
}

export default SSoft_Related_Pages;
